export default "__VITE_ASSET__BKjZk7se__"